import React from 'react';
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import { Modal } from "react-bootstrap";
import { formatNumber, ucFirst, formatDate } from '../../../../../../util/Helpers';
import ErrorMessage from './ErrorMessage';


const CreateUser = ({show, action: {action, error, actedOn, data}, onHide}) => {

    return <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Modal.Header >
              <Modal.Title id="contained-modal-title-vcenter">
                
                <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                    />
                </span>{action}
              </Modal.Title>
              <button type="button" className="close" onClick={onHide}>
                  <span aria-hidden="true" className="d-block">×</span>
                  <span className="sr-only">Close</span>
               </button>
            </Modal.Header>
            <Modal.Body >
                <ErrorMessage {...{error}} />
                <div className="mx-lg-5 px-lg-5">
    
                    <h6 className="font-weight-bolder mb-3">Basic Details:</h6>
                    <div className="text-dark-50 line-height-lg">
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Username: <h6 className="d-inline px-3">{data?.basic.username}</h6>
                            </div>
                            <div className="col-xl-6">
                                Email: <h6 className="d-inline px-3">{data?.basic.email}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                First Name: <h6 className="d-inline px-3">{data?.basic.firstName}</h6>
                            </div>
                            <div className="col-xl-6">
                                Last Name: <h6 className="d-inline px-3">{data?.basic.lastName}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Middle Name: <h6 className="d-inline px-3">{data?.basic.middleName}</h6>
                            </div>
                            <div className="col-xl-6">
                                Phone: <h6 className="d-inline px-3">{data?.basic.phone}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Password: <h6 className="d-inline px-3">{data?.basic.password}</h6>
                            </div>
                            <div className="col-xl-6">
                            {data?.identificationData?.type?.toUpperCase() ?? "ID"}: <h6 className="d-inline px-3">{`${data?.identificationData?.value ? "******" : ""}${data?.identificationData?.value?.substr(-5) ?? ""}`}</h6>
                            </div>
                        </div>
                    </div>
                    <div className="separator separator-dashed my-5"></div>
                    {/* <!--end::Section--> */}
                    {/* <!--begin::Section--> */}
                    <h6 className="font-weight-bolder mb-3">Personal Information:</h6>
                    <div className="text-dark-50 line-height-lg">
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Gender: <h6 className="d-inline px-3">{data?.personalData?.gender}</h6>
                            </div>
                            <div className="col-xl-6">
                                Marital Status: <h6 className="d-inline px-3">{data?.personalData?.marital}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                            Date of Birth: <h6 className="d-inline px-3">{data?.personalData?.birthDay ? [data?.personalData.birthDay, data?.personalData.birthMonth, data?.personalData.birthYear].join("/"): ""}</h6>
                            </div>
                            <div className="col-xl-6">
                                Politically exposed: <h6 className="d-inline px-3">{data?.personalData?.politicallyExposedNames}</h6>
                            </div>
                        </div>
                    </div>
                    <div className="separator separator-dashed my-5"></div>
                    {/* <!--end::Section--> */}

                    {/* <!--begin::Section--> */}
                    <h6 className="font-weight-bolder mb-3">Next of Kin:</h6>
                    <div className="text-dark-50 line-height-lg">
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                First Name: <h6 className="d-inline px-3">{data?.trustData?.nextOfKin?.firstName}</h6>
                            </div>
                            <div className="col-xl-6">
                                Last Name: <h6 className="d-inline px-3">{data?.trustData?.nextOfKin?.lastName}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Email: <h6 className="d-inline px-3">{data?.trustData?.nextOfKin?.email}</h6>
                            </div>
                            <div className="col-xl-6">
                                Phone: <h6 className="d-inline px-3">{data?.trustData?.nextOfKin?.phone}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-12">
                                Relationship: <h6 className="d-inline px-3">{data?.trustData?.nextOfKin?.relationship}</h6>
                            </div>
                        </div>
                    </div>
                    <div className="separator separator-dashed my-5"></div>
                    {/* <!--end::Section--> */}


                    {/* <!--begin::Section--> */}
                    <h6 className="font-weight-bolder mb-3">Trust Person:</h6>
                    <div className="text-dark-50 line-height-lg">
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                First Name: <h6 className="d-inline px-3">{data?.trustData?.trustInfo?.firstName}</h6>
                            </div>
                            <div className="col-xl-6">
                                Last Name: <h6 className="d-inline px-3">{data?.trustData?.trustInfo?.lastName}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Email: <h6 className="d-inline px-3">{data?.trustData?.trustInfo?.email}</h6>
                            </div>
                            <div className="col-xl-6">
                                Phone: <h6 className="d-inline px-3">{data?.trustData?.trustInfo?.phone}</h6>
                            </div>
                        </div>
                    </div>
                    <div className="separator separator-dashed my-5"></div>
                    {/* <!--end::Section--> */}


                    {/* <!--begin::Section--> */}
                    <h6 className="font-weight-bolder mb-3">Address Details:</h6>
                    <div className="text-dark-50 line-height-lg">
                        <div>
                            Address Line 1: <h6 className="d-inline px-3">{data?.addressData?.street1}</h6>
                        </div>
                        <div>
                            Address Line 2: <h6 className="d-inline px-3">{data?.addressData?.street2}</h6>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Postcode: <h6 className="d-inline px-3">{data?.addressData?.postalCode}</h6>
                            </div>
                            <div className="col-xl-6">
                                City: <h6 className="d-inline px-3">{data?.addressData?.city}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                State / Province: <h6 className="d-inline px-3">{data?.addressData?.province}</h6>
                            </div>
                            <div className="col-xl-6">
                                Country: <h6 className="d-inline px-3">{data?.addressData?.country}</h6>
                            </div>
                        </div>
                    </div>
                    <div className="separator separator-dashed my-5"></div>
                    {/* <!--end::Section--> */}
                    {/* <!--begin::Section--> */}
                    <h6 className="font-weight-bolder mb-3">Employment Details:</h6>
                    <div className="text-dark-50 line-height-lg">
                        <div>
                            Employment status: <h6 className="d-inline px-3">{data?.employmentData?.status}</h6>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Company name: <h6 className="d-inline px-3">{data?.employmentData?.company}</h6>
                            </div>
                            <div className="col-xl-6">
                                Type of employment: <h6 className="d-inline px-3">{data?.employmentData?.type}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Position: <h6 className="d-inline px-3">{data?.employmentData?.position}</h6>
                            </div>
                            <div className="col-xl-6">
                                Company Address: <h6 className="d-inline px-3">{data?.employmentData?.address}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Zip / Postcode: <h6 className="d-inline px-3">{data?.employmentData?.zip}</h6>
                            </div>
                            <div className="col-xl-6">
                                City: <h6 className="d-inline px-3">{data?.employmentData?.city}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                State / Province: <h6 className="d-inline px-3">{data?.employmentData?.state}</h6>
                            </div>
                            <div className="col-xl-6">
                                Country: <h6 className="d-inline px-3">{data?.employmentData?.country}</h6>
                            </div>
                        </div>

                    </div>
                    {/* <!--end::Section--> */}

                    <div className="separator separator-dashed my-5"></div>
                    {/* <!--end::Section--> */}
                    {/* <!--begin::Section--> */}
                    <h6 className="font-weight-bolder mb-3">Investment Profile:</h6>
                    <div className="text-dark-50 line-height-lg">
                        <div>
                            Approximate annual income (USD): <h6 className="d-inline px-3">{formatNumber(data?.investmentData?.annualIncome)}</h6>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Liquid net worth (USD): <h6 className="d-inline px-3">{formatNumber(data?.investmentData?.networthLiquid)}</h6>
                            </div>
                            <div className="col-xl-6">
                                Total net worth (USD): <h6 className="d-inline px-3">{formatNumber(data?.investmentData?.networthTotal)}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Investment objectives: <h6 className="d-inline px-3">{data?.investmentData?.investmentObjectives}</h6>
                            </div>
                            <div className="col-xl-6">
                                Investment experience: <h6 className="d-inline px-3">{data?.investmentData?.investmentExperience}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Risk tolerance: <h6 className="d-inline px-3">{data?.investmentData?.riskTolerance}</h6>
                            </div>
                            <div className="col-xl-6">
                                User's tax rate: <h6 className="d-inline px-3">{data?.investmentData?.taxRate}</h6>
                            </div>
                        </div>
                    </div>
                    {/* <!--end::Section--> */}

                    <div className="separator separator-dashed my-5"></div>
                    {/* <!--end::Section--> */}
                    {/* <!--begin::Section--> */}
                    <h6 className="font-weight-bolder mb-3">Compliance & AML:</h6>
                    <div className="text-dark-50 line-height-lg">
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Funding sources: <h6 className="d-inline px-3">{data?.complianceData?.fundingSources?.join(", ")}</h6>
                            </div>
                            <div className="col-xl-6">
                                Expected transfers: <h6 className="d-inline px-3">{formatNumber(data?.complianceData?.transferFrequencyPerMonth)}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Expected annual transfer: <h6 className="d-inline px-3">{formatNumber(data?.complianceData?.transferTotalExpected)}</h6>
                            </div>
                            <div className="col-xl-6">
                                Past 12 months: <h6 className="d-inline px-3">{formatNumber(data?.complianceData?.investmentHistory12M)}</h6>
                            </div>
                        </div>
                    </div>
                    {/* <!--end::Section--> */}

                    <div className="separator separator-dashed my-5"></div>
                    
                    <h6 className="font-weight-bolder mb-3">Disclosure:</h6>
                    <div className="text-dark-50 line-height-lg">
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Terms of Use: <h6 className="d-inline px-3">{ucFirst(`${!!data?.disclosuresData?.termsOfUse}`)}</h6>
                            </div>
                            <div className="col-xl-6">
                                Customer Agreement: <h6 className="d-inline px-3">{ucFirst(`${!!data?.disclosuresData?.customerAgreement}`)}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                IRA Agreement: <h6 className="d-inline px-3">{ucFirst(`${!!data?.disclosuresData?.iraAgreement}`)}</h6>
                            </div>
                            <div className="col-xl-6">
                                Market Data Agreement: <h6 className="d-inline px-3">{ucFirst(`${!!data?.disclosuresData?.marketDataAgreement}`)}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Margin Agreement: <h6 className="d-inline px-3">{ucFirst(`${!!data?.disclosuresData?.marginAgreement}`)}</h6>
                            </div>
                            <div className="col-xl-6">
                                Account Agreement: <h6 className="d-inline px-3">{ucFirst(`${!!data?.disclosuresData?.accountAgreement}`)}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Rule 14b: <h6 className="d-inline px-3">{ucFirst(`${!!data?.disclosuresData?.rule14b}`)}</h6>
                            </div>
                            <div className="col-xl-6">
                                Privacy Policy: <h6 className="d-inline px-3">{ucFirst(`${!!data?.disclosuresData?.privacyPolicy}`)}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Data Sharing: <h6 className="d-inline px-3">{ucFirst(`${!!data?.disclosuresData?.dataSharing}`)}</h6>
                            </div>
                            <div className="col-xl-6">
                                IP Address: <h6 className="d-inline px-3">{data?.disclosuresData?.ipAddress}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                        {/* <!--end::Input--> */}
                        <div className="row">
                            <div className="col-xl-6">
                                Signed By: <h6 className="d-inline px-3">{data?.disclosuresData?.signedBy}</h6>
                            </div>
                            <div className="col-xl-6">
                                Date: <h6 className="d-inline px-3">{formatDate(data?.disclosuresData?.date)}</h6>
                            </div>
                        </div>
                        {/* <!--end::Input--> */}
                    </div>
                    
                </div>    
                
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-5"
                >
                    Okay
                </button>
            </Modal.Footer>
          </Modal>
}

export default CreateUser;